import React, { ReactNode } from 'react';
import './Loader.scss';

interface LoaderProps {
  type?: string;
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ type, text }: LoaderProps) => {
  return (
    <div className={type === undefined ? `loader` : `loader ${type}`}>
      <div className="spinner-border" role="status"></div>
      <div>{text === undefined ? 'در حال بارگزاری' : text}</div>
    </div>
  );
};

export default Loader;
